import React from 'react'
import './IconStyles.css';
import { LuClipboardCheck } from "react-icons/lu";

export const RecipeResultsIcon = (props) => (
    <div style={{minWidth: "1.75em"}}>
        <LuClipboardCheck
            color={props.color ? props.color : undefined}
            size={props.size ? props.size : "1.15em"}
        />
    </div>
)
